module.exports = __webpack_public_path__ + "Server-Unknown.Ftp.09f17aa59f10187cc6cc329d5e807678.hashedasset.svg";